import { 
    DevToolsState,
    DevToolsTypes,
    TOGGLE_SHOW_TARGETS
} from './types';

const initialState :DevToolsState = {
    showTargets: false,
}

export function devToolsReducer(
    state = initialState, 
    action : DevToolsTypes): DevToolsState {
        switch(action.type){
            case TOGGLE_SHOW_TARGETS:
                return {...state, showTargets: !state.showTargets};
            default:
                return {...state}
        }
}
